import styled from '@emotion/styled';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' }) <PropsType>`
    height: auto;
`;

export const AKBetsLogo = observer('AKBetsLogo', ({ className, onClick }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        onClick={onClick}
        width='127'
        height='32'
        viewBox='0 0 127 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='m18.52 27.485-1.056-3.498H9.92l-1.086 3.498H2.949l7.715-22.97h6.056l7.715 22.97H18.52Zm-4.8-15.908-2.114 6.892h4.2l-2.087-6.892h.001ZM38.519 27.485l-4.43-7.92-2.828 4.08v3.84h-5.485V4.515h5.485v9.907l6.973-9.907h6.23l-6.8 9.875 7.485 13.097H38.52l-.001-.002ZM65.431 15.76c2 .067 4.057 1.509 4.057 5.244 0 3.736-2.43 6.48-6.486 6.48h-10.4V4.516h10.4c3.573 0 5.915 2.434 5.915 6.137 0 3.428-2.056 4.904-3.486 4.972v.137-.002Zm-7.342-1.885h3.401c1.228 0 2.056-.857 2.056-2.16 0-1.304-.828-2.093-1.971-2.093h-3.486v4.253Zm3.686 8.503c1.314 0 2.086-.927 2.086-2.296 0-1.37-.829-2.126-2.028-2.126h-3.744v4.422h3.686ZM86.83 27.485H71.603V4.515h15.114v5.554h-9.628v3.394h8.856v5.04h-8.856v3.428h9.743v5.554ZM99.973 10.171v17.314h-5.514V10.17h-6V4.515h17.515v5.656h-6.001ZM123.543 10.686l-5.37 1.304c-.371-2.194-1.772-2.879-2.885-2.879-1.2 0-2.028.72-2.028 1.85 0 .652.199 1.235 1.114 1.474l3.885 1.098c3.514 1.063 5.457 3.12 5.457 6.822 0 5.383-4.171 7.645-8.142 7.645-4.657 0-8.201-2.71-8.743-7.098l5.6-1.267c.458 2.16 1.629 3.05 3.258 3.05 1.314 0 2.257-.65 2.257-1.85 0-.685-.258-1.234-1.314-1.544l-3.971-1.132c-3.2-.89-5.258-2.845-5.258-6.65 0-4.834 3.401-7.509 7.886-7.509 4.486 0 7.572 2.4 8.258 6.686h-.004Z' fill='#E8530E'/>
    </SvgElement>
));



